var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 31,
    viewBox: "0 0 14 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3912 15.6933H9.25956V30.8547H2.9827V15.6933H0V10.3651H2.9827V6.9152C2.91569 6.06747 3.03336 5.21529 3.3276 4.41744C3.62184 3.61959 4.08565 2.89507 4.68703 2.29384C5.28841 1.6926 6.01305 1.22898 6.81098 0.934939C7.6089 0.640899 8.46111 0.523441 9.30882 0.590668L13.9521 0.608148V5.7806H10.5817C10.3936 5.77016 10.2056 5.80164 10.0311 5.87278C9.85672 5.94391 9.70029 6.05291 9.57316 6.19191C9.44602 6.3309 9.35137 6.49641 9.29604 6.67646C9.2407 6.85651 9.22607 7.04661 9.2532 7.23301V10.3699H13.9378L13.3912 15.6933Z",
    fill: "#47358D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.836202a3da356a4dee5a496f26c69758.svg";
export { ForwardRef as ReactComponent };